<div class="row" class="row  Page-Header">
  <div class="col-12">
    <h6 class=" mt-2"><strong>Subject Management : </strong>Resource Assigment List</h6>
  </div>
</div>
<form [formGroup]="Resourceform">
  <div class="row pt-3">


    <div class="col-3">
      <select class="form-control form-control-sm" formControlName="LanguageTypeCode"
        (change)="getresourcevalue($event)" style="padding: 3px;width: 300px;">
        <option hidden selected value=null>Select Language</option>
        <option class="border-bottom" *ngFor="let s of getlanguage" [value]="s.Code">{{s.Description}}</option>
      </select>
    </div>
    <div class="col-3">
      <select class="form-control form-control-sm" formControlName="SubjectId" style="padding: 3px;width: 300px;">
        <option hidden selected value=null>Select Subject</option>
        <option class="border-bottom" *ngFor="let s of getsubjectlist" [value]="s.Code">{{s.Description}}</option>
      </select>
    </div>
    <div class="col-3">
      <select class="form-control form-control-sm" formControlName="ResourceType" style="padding: 3px;width: 300px;"
        (change)="getresourcevalue($event)">
        <option hidden selected value=null>Select Role Type</option>
        <option class="border-bottom" *ngFor="let s of getroletype" [value]="s.Code">{{s.Code}}</option>
      </select>
    </div>
    <div class="col-3">
      <select class="form-control form-control-sm" formControlName="PowerUserID" style="padding: 3px;width: 300px;">
        <option hidden selected value=null>Select Resource Name</option>
        <option class="border-bottom" *ngFor="let s of getresourcedetails" [value]="s.Power_User_ID">{{s.Full_Name}}
        </option>
      </select>

  </div>

    <div class="col-10 pt-2">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" (click)="checkbox()">
        <label class="form-check-label" for="exampleCheck1">Only Currently Active Role Assignment</label>
      </div>

    </div>
    <div class="col-2">
      <div class="d-flex">
        <div class="px-1 pt-2">
          <button type="button" (click)="ResourceAssignSearch()" class="btn btn-sm bl-btn">Search</button>
        </div>
        <div class="px-1 pt-2">
          <button type="button" (click)="listResourceCancel()"
            class="btn btn-sm  btn-light bg-light border">Clear</button>
        </div>
      </div>
    </div>


  </div>

</form>


<div class="row pt-3" >
  <div class="col-12">
    <div class="p-1 scroll-style px-1 border w-100" style="width: 100%;">
      <div class="d-flex border-bottom">
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">No.</div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Language</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Subject</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Major Topic</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Concept</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-1</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-2</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-3</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-4</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-5</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Sub-Concept Lvl-6</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Name</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Role</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">Start Date</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
          <p class="Rl-col-1">End Date</p>
        </div>
        <div class="px-1 sticky-col last-col px-2" style="background: #efecec;">
        </div>
      </div>

      <div class="d-flex invRow"
        (click)="RedirecttoAssignedresource(s.Subject_Role_Assignment_ID,s.Subject_Id)"
        *ngFor="let s of Searchlistresponse; let i = index">
        <div class="px-2 text-right pt-1 pb-1  border-bottom">{{i+1}}</div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Subject_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Subject_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Major_Topic_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Concept_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL1_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL2_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL3_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL4_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL5_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.SCL6_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Assigned_To}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Power_User_Role_Type_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Start_Date  | date: "dd-MMM-yyyy" }}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.End_Date  | date: "dd-MMM-yyyy"}}</p>
        </div>
        <div class="px-1 sticky-col last-col px-2">
          <div class="justify-content-center align-self-center">
            <button type="button" (click)="RemoveResource(s.Subject_Role_Assignment_ID,s.Subject_Id)"
              *ngIf="s.End_Date==null" class="btn btn-sm btn-light border">Remove</button>
          </div>

        </div>
      </div>


      <div class="d-flex" *ngIf="!Searchlistresponse">
        <div class="p-3 m-3">No search results</div>
      </div>

    </div>
  </div>
</div>

<div class="modal fade  show Model_popup1" *ngIf="EditResourcePopup" id="ResourceAssigned">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="ResourceAssignedTitle">Edit Resource Assignment</h6>
        <button type="button" class="close" [hidden]='!ResourceAssignform||(ResourceAssignform&&!EditResourceflag)' *ngIf="!ResourceAssignform||(ResourceAssignform&&EditResourceflag)"
          (click)="EditResouceClosepopup()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
        <button type="button" class="close" [hidden]='!ResourceAssignform||(ResourceAssignform&&EditResourceflag)' *ngIf="!ResourceAssignform||(ResourceAssignform&&!EditResourceflag)"
          (click)="cancelEditPopup()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="row">
        <div class="col-12">
          <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
        </div>
      </div>
      <div class="modal-body px-3 py-0">

        <app-subject-resource-assignment #one (DisableButton)="DisableButton($event)" (popup)="popup($event)"(refresh)="refresh($event)"
          (reset)="reset($event)" [EditResourcePopup]="EditResourcePopup"
          [RedirectAssignedresourceId]="RedirectAssignedresourceId"></app-subject-resource-assignment>

        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex">
              <div class="col-3"></div>
              <div class="px-1">
                <button type="button" [disabled]="!ResourceAssignform||(ResourceAssignform&&!EditResourceflag)"
                  (click)="one.Save()" class="btn btn-sm bl-btn">Save</button>
              </div>
              <div class="px-1">
                <!-- <button type="button" *ngIf="!ResourceAssignform||(ResourceAssignform&&EditResourceflag)"
                  (click)="EditResouceClosepopup()" [hidden]='!ResourceAssignform||(ResourceAssignform&&!EditResourceflag)' class="btn btn-sm bg-light border">Close</button>
                <button type="button" *ngIf="!ResourceAssignform||(ResourceAssignform&&!EditResourceflag)"
                  (click)="cancelEditPopup()" [hidden]='!ResourceAssignform||(ResourceAssignform&&EditResourceflag)'class="btn btn-sm bg-light border">Close</button> -->
                  <button type="button"
                  (click)="cancelEditPopup()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade show modal-dialog-centered" id="modelconfirm" *ngIf="EditResouceclosepopupflag"
  [hidden]="!EditResouceclosepopupflag" style="padding-right: 4px;display: block;background-color: #5853534d;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header mx-2 p-1">
        <h6 class="modal-title" style="
        font-size: 16px;
        font-weight: 500;" id="relocatedheader">Save Changes</h6>
        <button type="button" class="close" (click)="EditResouceClosepopup()" style="font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body py-0" style="
      font-size: 16px;
      font-weight: 500;">
        <div class="row py-2 mx-3 pt-3">
          <div class="col-12">
            <label>Do you want to save changes?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex flex-row-reverse">
              <div class="px-1">
                <button type="button" (click)="cancelEditPopup()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
              <div class="px-1">
                <button type="button" (click)="one.Save()" class="btn btn-sm bl-btn">Save</button>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<div class="modal fade show Model_popup1" *ngIf="RemoveResourcePopup" id="ResourceAssigned">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="ResourceAssignedTitle">Remove Resource Assignment</h6>
        <button type="button" class="close" *ngIf="RemoveResourceAssignform && check" (click)="RemoveResouceClosepopup()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
          <button type="button" class="close" *ngIf="!RemoveResourceAssignform || !check" (click)="cancelRemoveResourcePopup($event)"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12 p-0 border-bottom">
            <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
          </div>
        </div>
        <app-subject-remove-resource-assignment #one (DisableButton1)="DisableButton1($event)" (cancelpopup)="cancelpopup($event)" (cancelRemoveResourcePopup)="cancelRemoveResourcePopup($event)"
          [RemoveResourcePopup]="RemoveResourcePopup" [RemoveResouceclosepopupflag]="RemoveResouceclosepopupflag" [RedirectRemoveResourceId]="RedirectRemoveResourceId">
        </app-subject-remove-resource-assignment>
      </div>
    </div>
  </div>
  <div class="modal fade show modal-dialog-centered" id="modelconfirm" *ngIf="RemoveResouceclosepopupflag"
[hidden]="!RemoveResouceclosepopupflag" style="padding-right: 4px;display: block;background-color: #5853534d;">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header mx-2 p-1">
      <h6 class="modal-title" style="
      font-size: 16px;
      font-weight: 500;" id="relocatedheader">Save Changes</h6>
      <button type="button" class="close" (click)="RemoveResouceClosepopup()" style="font-size: 30px;outline: 0;">
        <span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body py-0" style="
    font-size: 16px;
    font-weight: 500;">
      <div class="row py-2 mx-3 pt-3">
        <div class="col-12">
          <label>Do you want to save changes?</label>
        </div>
      </div>
      <div class="row p-1">
        <div class="col-12">
          <div class=" d-flex flex-row-reverse">
            <div class="px-1">
              <button type="button" (click)="cancelRemoveResourcePopup($event)" class="btn btn-sm bg-light border">Cancel</button>
            </div>
            <div class="px-1">
              <button type="button" (click)="one.Save()" class="btn btn-sm bl-btn">Save</button>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

</div>


<!-- <div class="modal fade show modal-dialog-centered" id="model" *ngIf="EditResouceclosepopupflag"
  [hidden]="!EditResouceclosepopupflag" style="padding-right: 4px;display: block;background-color: #00000075;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header  p-1 py-0">
        <h6 class="modal-title" id="relocatedheader">Save Changes</h6>
      </div>
      <div class="modal-body">
        <div class="row p-3">
          <div class="col-12">
            <div class="d-flex">
              <div class="px-1">
                <button type="button"   (click)="cancelEditPopup()"  class="btn btn-sm bl-btn">Close</button>
              </div>
              <div class="px-1">
                <button type="button" (click)="EditResouceClosepopup()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
